import { queryOptions } from "@tanstack/react-query";
import { getScoreDetail, getScoreList, getTournamentRoundList } from "../v1/score.service";
import type { getScoreListForm } from "../dto/request/score.request";

/** 스코어 목록 조회 */
export const useGetScoreList = (form: getScoreListForm) => queryOptions({
    queryKey: ["score-list", form],
    queryFn: () => getScoreList(form),
    retry: 1
})

/** 스코어 상세 조회 */
export const useGetScoreDetail = (scoreId: string | number, roundId?: number | null) => queryOptions({
    queryKey: ["score-detail", scoreId, roundId ?? null],
    queryFn: () => getScoreDetail(scoreId, roundId),
    retry: 1
})

/** 대회 라운드 목록 조회 (MULTI_ROUND) */
export const useGetRoundList = (tournamentId: string | number | null | undefined) => queryOptions({
    queryKey: ["tournament-round-list", tournamentId],
    queryFn: () => getTournamentRoundList(tournamentId as string | number),
    enabled: tournamentId != null,
    retry: 1,
})
